import React from "react";
import style from "../../../App.module.scss";
import { Logo } from "../../../components/Logo/Logo";
import ContactIframe from "../../../ContactIframe";
import { getMessage, Message, MessageContext } from "@messageformat/react";
import classNames from "classnames";
import { colors } from "../../../colors";

const SolutionAmos = () => {
  const messageContext = React.useContext(MessageContext);

  return (
    <div
      style={{
        position: "relative",
        zIndex: 999,
        backgroundColor: colors.grayLight,
        padding: "60px 0",
      }}
    >
      <section className={style.pageInner} style={{ marginBottom: 0, padding: '0 16px' }}>
        <div className={classNames(style.heading, style.headingWithDownLine)}>
          <span>
            <Message id="landingPage.contactEndorsement.title" />
          </span>
          <h2>
            <Message id="landingPage.contactEndorsement.title2" />
          </h2>
        </div>

        <p
          style={{ marginBottom: "10px", marginTop: "40px" }}
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "landingPage.contactEndorsement.description"
            )(),
          }}
        />
        <p
          style={{ marginTop: "0", marginBottom: "10px" }}
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "landingPage.contactEndorsement.description2"
            )(),
          }}
        />
        <p
          style={{ marginTop: "0" }}
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "landingPage.contactEndorsement.description3"
            )(),
          }}
        />

        <ContactIframe />

        <Logo />
      </section>
    </div>
  );
};

export default SolutionAmos;
